<template>
	<div>
		<div class="inquiry-container">
			<div class="u-container">
				<form @submit.prevent="search" class="pt-4">
					<div class="columns">
						<div class="column col-4">
							<select ref="field" class="form-select">
								<option value="">선택</option>
								<option value="ar_title">제목</option>
								<option value="ar_content">내용</option>
							</select>
						</div>
						<div class="column">
							<input
								ref="keyword"
								class="form-input"
								type="text"
								placeholder="검색어"
							/>
						</div>

						<div class="column col-auto">
							<BaseBtn color="primary" type="submit" medium block>검색</BaseBtn>
						</div>
						<div v-if="isResetSorting" class="column col-12 mt-2">
							<BaseBtn
								@click="resetSorting"
								color="secondary"
								type="button"
								medium
								block
								>검색 초기화</BaseBtn
							>
						</div>
					</div>
				</form>

				<p class="desc pt-2 pb-4 u-text-center">
					[ 온라인상담 시간 : 평일 10:00 ~ 18:30 ]
				</p>
			</div>

			<DetailCardContainer>
				<InquiryListItem
					v-for="item in userInquiryList"
					:key="item.ar_id"
					:item="item"
				></InquiryListItem>
			</DetailCardContainer>

			<InfiniteLoading
				ref="infiniteLoading"
				@infinite="infinite"
			></InfiniteLoading>

			<router-link class="btn-inquiry" :to="{ name: 'inquiryEdit' }"
				>문의<br />하기</router-link
			>
		</div>
	</div>
</template>

<script>
import DetailCardContainer from '@/components/common/DetailCardContainer';
import BaseBtn from '@/components/common/Btn';
import InfiniteLoading from '@/components/common/InfiniteLoading';
import InquiryListItem from './InquiryListItem';

export default {
	components: {
		DetailCardContainer,
		BaseBtn,
		InfiniteLoading,
		InquiryListItem,
	},
	data() {
		return {
			page: 1,
			field: '',
			keyword: '',
		};
	},
	computed: {
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		userInquiryList() {
			return this.$store.getters['inquiryStore/userInquiryList'];
		},
		isResetSorting() {
			return this.keyword;
		},
	},
	methods: {
		async fetchUserInquiryList() {
			const payload = {
				page: this.page,
				userId: this.userId,
				field: this.field,
				keyword: this.keyword,
			};

			return await this.$store.dispatch(
				'inquiryStore/getUserInquiryList',
				payload,
			);
		},
		infinite(state) {
			this.fetchUserInquiryList().then(({ data }) => {
				if (data.code !== '00000' || data.page > data.totalPage) {
					this.page--;
					state.complete();
				}
				if (data.page <= data.totalPage) {
					this.page++;

					/**
					 * 데이터 가져오는 속도가 빨라서
					 * 스크롤시 무한 스크롤링 로딩 아이콘 노출 시간이 짧아서 보이지 않음.
					 * 임의로 가져오는 속도 늦춤.
					 */
					setTimeout(() => state.loaded(), 400);
				}
			});
		},
		search() {
			this.field = this.$refs.field.value;
			this.keyword = this.$refs.keyword.value;

			this.initRender();
			this.$refs.infiniteLoading.resetInfiniteLoading();
		},
		initRender() {
			this.page = 1;
			this.$store.dispatch('inquiryStore/initUserInquiryList');
		},
		resetSorting() {
			this.$refs.field.value = '';
			this.$refs.keyword.value = '';
			this.search();
		},
	},
};
</script>

<style scoped>
.inquiry-container {
	--inquiry-button-size: 48px;
	padding-bottom: calc(var(--inquiry-button-size) + 1rem);
}

.btn-inquiry {
	position: fixed;
	right: 1rem;
	bottom: calc(env(safe-area-inset-bottom) + 3.75rem + 1rem);
	display: flex;
	justify-content: center;
	align-items: center;
	width: var(--inquiry-button-size);
	height: var(--inquiry-button-size);
	border-radius: 50%;
	background: #222;
	color: #fff;
	font-size: 0.75rem;
	line-height: 1.3;
}
</style>
